<template>
    <div>
        <pop-form v-if="show" width="990px" body-max-height="560px">
            <template v-slot:title>
                {{title}}
                <span class="close" @click="close">
                    <i class="el-icon-close"></i>
                </span>
            </template>
            <div class="info-box">
                <div class="info">
                    <div class="top">
                        <div class="nickname">
                            {{userInfo.name}} {{userInfo.mobile}}
                            <el-tag type="warning" v-if="userInfo.is_vip">{{userInfo.vip_name}}</el-tag>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="item">会员卡号： {{userInfo.user_card_id}}</div>
                        <div class="item">加入时间： {{userInfo.create_datetime}}</div>
                        <div class="item">最后消费时间： {{userInfo.last_cost_datetime}}</div>
                    </div>
                </div>
                <div class="total">
                    <div class="row1">
                        <div class="col">
                            <div class="label">余额</div>
                            <div class="value">
                                <span class="hover" @click="clickMoney">{{userInfo.money}}</span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="label">卡项</div>
                            <div class="value">
                                <span class="hover" @click="showCardHistory">{{userInfo.card_num ? userInfo.card_num : 0}}</span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="label">积分</div>
                            <div class="value hover" @click="showScoreHistory">{{userInfo.score ? userInfo.score : 0}}</div>
                        </div>
                        <div class="col">
                            <div class="label">优惠券</div>
                            <div class="value">
                                <span class="hover" @click="showError">0</span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="label">赠送项目</div>
                            <div class="value hover" @click="showGivePro">{{userInfo.give_pro_sur_num ? userInfo.give_pro_sur_num : 0}}</div>
                        </div>
                    </div>
                    <div class="row2">
                        <div class="col">
                            <div class="label">累计消费次数</div>
                            <div class="value">{{userInfo.total_cost_num ? userInfo.total_cost_num : 0}}</div>
                        </div>
                        <div class="col">
                            <div class="label">累计消费金额</div>
                            <div class="value">{{userInfo.total_cost_money ? userInfo.total_cost_money : "0.00"}}</div>
                        </div>
                        <div class="col">
                            <div class="label">累计充值次数</div>
                            <div class="value">{{userInfo.total_recharge_num ? userInfo.total_recharge_num : 0}}</div>
                        </div>
                        <div class="col">
                            <div class="label">累计充值金额</div>
                            <div class="value">{{userInfo.total_recharge_money ? userInfo.total_recharge_money : "0.00"}}</div>
                        </div>
                        <div class="col">
                            <div class="label">累计赠送金额</div>
                            <div class="value">{{userInfo.total_give_money ? userInfo.total_give_money : "0.00"}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="other-box">
                <el-tabs v-model="activeIndex" type="card" @tab-click="switchTab">
                    <el-tab-pane label="基本资料">
                        <div class="base-info">
                            <div class="row">
                                <div class="label">会员性别：</div>
                                <div class="value">{{userInfo.sex === "2" ? "女" : "男"}}</div>
                            </div>
                            <div class="row">
                                <div class="label">会员等级：</div>
                                <div class="value">{{userInfo.vip_name}}</div>
                            </div>
                            <!--<div class="row">-->
                                <!--<div class="label">消费密码：</div>-->
                                <!--<div class="value">{{userInfo.pay_password}}</div>-->
                            <!--</div>-->
                            <div class="row">
                                <div class="label">有效期至：</div>
                                <div class="value">{{userInfo.vip_expire ? userInfo.vip_expire : "永久"}}</div>
                            </div>
                            <div class="row">
                                <div class="label">生日类型：</div>
                                <div class="value">{{userInfo.birthday_type === "2" ? "农历" : "阳历"}}</div>
                            </div>
                            <div class="row">
                                <div class="label">生日日期：</div>
                                <div class="value">{{userInfo.birthday}}</div>
                            </div>
                            <div class="row">
                                <div class="label">会员地址：</div>
                                <div class="value">{{userInfo.address}}</div>
                            </div>
                            <div class="row">
                                <div class="label">会员备注：</div>
                                <div class="value">{{userInfo.remarks}}</div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </pop-form>

        <!--会员对账-->
        <store-user-money-data v-model="storeUserMoneyDataShow" :store-uid="storeUid" />
        <!--积分记录-->
        <store-user-score-history v-model="storeUserScoreHistoryShow" :store-uid="storeUid" />
        <!--赠送项目记录-->
        <store-user-give-product-history v-model="storeUserGiveProductShow" :store-uid="storeUid" />
        <!--卡项记录-->
        <card-sale-history-for-cash v-model="cardHistoryShow" :store-uid="storeUid" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import StoreUserMoneyData from "@/model/StoreUser/StoreUserMoneyData";
    import StoreUserScoreHistory from "@/model/StoreUser/StoreUserScoreHistory";
    import StoreUserGiveProductHistory from "@/model/StoreUser/StoreUserGiveProductHistory";
    import CardSaleHistoryForCash from "@/model/Card/CardSaleHistoryForCash";
    export default {
        name: "StoreUserInfo",
        components: {
            CardSaleHistoryForCash,
            StoreUserGiveProductHistory, StoreUserScoreHistory, StoreUserMoneyData, PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [String, Number],
                default: 0
            }
        },
        data: () => ({
            title: "会员详情",
            userInfo: {},
            activeIndex: 0,

            storeUserMoneyDataShow: false,      //会员对账
            storeUserScoreHistoryShow: false,
            storeUserGiveProductShow: false,
            cardHistoryShow: false,
        }),
        methods: {
            //获取用户信息
            getUserInfo: function () {
                obj.postData("store_user/get_store_user_all_info", {id: this.storeUid}, res => {
                    if(res.errcode === 0){
                        this.userInfo = res.data;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //暂未开放
            showError: function () {
                obj.message.error("暂未开放");
            },
            //关闭
            close: function () {
                this.$emit("showChange", false);
            },
            //点击余额
            clickMoney: function () {
                this.storeUserMoneyDataShow = true;
            },
            //切换tab
            switchTab: function () {

            },
            //显示积分记录
            showScoreHistory: function () {
                this.storeUserScoreHistoryShow = true;
                // this.showError();
            },
            //显示赠送项目
            showGivePro: function () {
                this.storeUserGiveProductShow = true;
            },
            //显示卡项记录
            showCardHistory: function () {
                this.cardHistoryShow = true;
            }
        },
        watch: {
            show: function (v) {
                if(v) this.getUserInfo();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
        line-height: 24px;
        cursor: pointer;
    }
    .info-box .info{
        padding: 20px 26px;
        background: #f7f8fa;
    }
    .info-box .info>.top{
        display: flex;
        flex-flow: row nowrap;
    }
    .info-box .info .nickname{
        flex: 1;
        font-size: 18px;
        font-weight: bold;
        line-height: 25px;
        color: #303133;
    }
    .info-box .info .tool-box{
        width: 100px;
        text-align: right;
    }
    .info-box .info>.bottom{
        font-size: 14px;
        line-height: 20px;
        margin-top: 5px;
        color: #303133;
        display: flex;
    }
    .info-box .info>.bottom>.item{
        width: 350px;
    }

    .total{
        padding: 0px 0px 20px 60px;
        line-height: 25px;
    }
    .total .row1{
        display: flex;
        flex-flow: row nowrap;
        margin-top: 40px;
    }
    .total .row1>.col{
        width: 200px;
    }
    .total .row1 .value{
        color: #6cb1e1;
        font-size: 18px;
        font-weight: bold;
    }
    .total .row2{
        display: flex;
        flex-flow: row nowrap;
        margin-top: 40px;
    }
    .total .row2>.col{
        width: 200px;
    }
    .total .row2 .value{
        color: #999999;
        font-size: 18px;
        font-weight: bold;
    }

    .other-box{
        margin-top: 16px;
        padding: 16px;
        background: #FFFFFF;
    }
    .base-info{
        font-size: 14px;
        color: #333333;
        padding-bottom: 20px;
    }
    .base-info .row{
        height: 30px;
        line-height: 30px;
        width: 100%;
    }
    .base-info .row>.label{
        width: 100px;
        float: left;
        text-align: right;
    }
    .base-info .row>.value{
        margin-left: 100px;
        text-align: left;
        padding-left: 5px;
    }
    .hover{
        cursor: pointer;
    }
</style>
